<template>
  <app-panel :title="title">
    <course-list-item :course="course" />
  </app-panel>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";

const properties = defineProps<{
  course: CourseListView;
}>();

const title = computed(() =>
  properties.course.teacher
    ? `Session de ${properties.course.teacher.full_name}`
    : "Session associée",
);
</script>
